/*
 * @Author: 吴雪川
 * @information:
 * @Date: 2020-12-04 11:17:00
 */
import publicServe from "../../service/public/public";
import axios from "axios"
const OSS = require('ali-oss')
const co = require('co')
// 生成随即32uuid的包
let uuid = require('uuid');
let OSSConfig
if (process.env.REACT_APP_ENV === 'dev' || process.env.REACT_APP_ENV === 'pred') {
  OSSConfig = {
    uploadHost: 'https://qjdev-pred-images.oss-cn-beijing.aliyuncs.com', // OSS上传地址
    type: 'scs',
    ossParams: {
      path: 'merchant/',
      bucket: 'qjdev-pred-images'
    }
  }
} else if(process.env.REACT_APP_ENV=== 'prod'){
  OSSConfig = {
    uploadHost: 'https://qjprod-images.oss-cn-beijing.aliyuncs.com', // OSS上传地址
    type: 'scs',
    ossParams: {
      path: 'tsfzx_institution/',
      bucket: 'qjprod-images'
    }
  }
}

function upload (event) {
  return new Promise((resolve, reject) => {
    let randomName = `${OSSConfig.ossParams.path}${uuid.v1()}`
    let res = publicServe.getOssConfig('image').then(( data ) => {
      // let data = JSON.parse(res)
      let formData = new FormData();
      formData.append("success_action_status", "200");
      formData.append("policy", data.policy);
      formData.append("x-oss-signature", data.signature);
      formData.append("x-oss-signature-version", data.x_oss_signature_version);
      formData.append("x-oss-credential", data.x_oss_credential);
      formData.append("x-oss-date", data.x_oss_date);
      formData.append("key", randomName + event.name); // 文件名
      formData.append("x-oss-security-token", data.security_token);
      formData.append("file", event); // file 必须为最后一个表单域
      axios.post(data.bucket_url,formData, {
        headers:{
          'Content-Type': 'multipart/form-data'
        }
      }).catch(errorData => {
        // 因为拦截器的判断逻辑，上传成功也只能走到catch
        let { status,statusText } = errorData;
        if(status === 200){
          resolve({url:`${data.bucket_url}${randomName + event.name}`,name: randomName + event.name})
        }else{
          reject({message:statusText,statusCode:status})
        }
      })
    });
  })
  // return new Promise((resolve, reject) => {
  //   let client = new OSS({
  //     region: OSSConfig.ossParams.region,
  //     accessKeyId: OSSConfig.ossParams.accessKeyId,
  //     accessKeySecret: OSSConfig.ossParams.accessKeySecret,
  //     bucket: OSSConfig.ossParams.bucket
  //   })
  //   let file = event
  //   let randomName = `${OSSConfig.ossParams.path}${uuid.v1()}`
  //   co(function* () {
  //     let result = yield client.multipartUpload(randomName, file)
  //     resolve({url:`${OSSConfig.uploadHost}/${result.name}`,name: result.name})
  //   }).catch(function (err) {
  //     reject(err)
  //   })
  // })
}

export default upload
